'use strict';

import type { UserEmailBatch } from '../../Entities/User/UserEmailBatch';
import { EntityCollection } from '../EntityCollection';

export class UserEmailBatchCollection extends EntityCollection<UserEmailBatch> {}
